<template>
  <div class="card">
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none">
      <symbol id="checkmark" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-miterlimit="10" fill="none"  d="M22.9 3.7l-15.2 16.6-6.6-7.1">
        </path>
      </symbol>
    </svg>
    <div class="card-body">
      <div class="check-group" id="printinstoreselectioncard-ctn">
        <input type="checkbox" id="printInStore" name="printInStore" class="reverse" v-on:change="highlightPrintInStore" v-bind:checked="$store.state.isPrintInStoreHighlighted" />
        <label for="printInStore" id="checkbox">
            <svg viewBox="0 0 100 100">
                <path class="box" d="M82,89H18c-3.87,0-7-3.13-7-7V18c0-3.87,3.13-7,7-7h64c3.87,0,7,3.13,7,7v64C89,85.87,85.87,89,82,89z"/>
                <polyline class="check" points="25.5,53.5 39.5,67.5 72.5,34.5 "/>
            </svg>
            <div>{{$t("parcelshopPicker.parcelshopQRCodeSelectionCard.showPrintInStore")}}</div>
        </label>
          <!-- <input type="checkbox" id="printInStore" class="checkbox" v-on:change="highlightPrintInStore" v-bind:checked="$store.state.isPrintInStoreHighlighted">
          <label for="printInStore" class="label">
              <span></span>
              <div>{{$t("parcelshopPicker.parcelshopQRCodeSelectionCard.showPrintInStore")}}</div>
          </label> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    highlightPrintInStore: function() {
      this.$store.commit('setIsPrintInStoreHighlighted', !this.$store.state.isPrintInStoreHighlighted);
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  padding-top: 5px;
  height: 70px;
}
.new .container .internal-page .check-group {
  width: unset !important;
  margin-top: 0!important;
  margin-bottom: 0!important;
    padding-top: 2px;
}

@media (max-width: 767.98px) { 
  .card {
    padding-top: 0;
  }
  .new .internal-page .check-group input[type="checkbox"] + label {
    padding: 1% 10px 1% 30px;
  }
}



input[type=checkbox] {
    display: none;
    pointer-events: none;

    & + label {
        border:none !important;
        padding: 3% 10px 3% 30px !important;
        cursor: pointer;
        font-size: .8em;
        display: grid;
        grid-template-columns: auto 3fr;
        text-align: left !important;

        svg {
            width: 2em;
            stroke: #96154a;
            stroke-width: 5;
            fill: white;
            float:left !important;

            .box {
                stroke-dasharray: 320;
                stroke-dashoffset: 0;
                fill: white !important;
            }
            .check {
                stroke-dasharray: 70;
                stroke-dashoffset: 70;
                fill: none;
            }
        }

        div{
            float:left;padding:6px;width: 90%;
    padding-top: 0px;}

        span {
            padding-top: .3em;
            margin-left: .3em;
        }
    }

    &:checked + label {
        .box {
            stroke-dashoffset: 0;
            transition: stroke-dashoffset .3s linear;
        }
        .check {
            stroke-dashoffset: 0;
            transition: stroke-dashoffset .3s linear;
        }
    }
}

.reverse {
    .box {
        stroke-dashoffset: 0;
        transition: stroke-dashoffset .3s linear;
    }
    .check {
        stroke-dashoffset: 70;
        transition: stroke-dashoffset .3s linear;
    }
}

</style>